import { render, staticRenderFns } from "./FactorGroupModal.vue?vue&type=template&id=bf420a2a&scoped=true&"
import script from "./FactorGroupModal.vue?vue&type=script&lang=js&"
export * from "./FactorGroupModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf420a2a",
  null
  
)

export default component.exports